import React, { useEffect, useState } from "react";
import "../../pages/analytics/analytics.css";
import "./smallModal.css";
import { Dialog, DialogActions, Typography } from "@mui/material";
import CustomButton from "../CustomButton";
import CustomDropdown from "../CustomDropdown";

const SmallModal = ({
  headerText = "Info",
  subHeaderText = "sub header text goes here",
  icon = <img src="/assets/orderDetailsIcons/ExclamationCircle-yellow.svg" />,
  outlinedBtnText = "",
  filledBtnText = "",
  outlinedBtnFunction = () => { },
  filledBtnFunction = () => { },
  toggleDialog = false,
  type = "secondary",
  dropdownData = null,
  isFilledBtnLoading = false
}) => {

  const handleKeyDown = (event) => {
    if (event.key === "Escape") {
      outlinedBtnFunction();
    }
  };

  return (
    <Dialog
      open={toggleDialog}
      PaperProps={{
        style: {
          backgroundColor: "#FFF",
          borderRadius: "12px",
          width: "416px",
        },
      }}
      onKeyDown={handleKeyDown}
    >
      <div className="small-modal" style={{ padding: "24px 24px 0px 24px" }}>
        <div className="modal-img">{icon}</div>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <Typography
            className="bodyB1Medium"
            sx={{
              color: "var(--character-title-85, rgba(0, 0, 0, 0.85))",
              marginBottom: "8px",
            }}
          >
            {headerText}
          </Typography>
          <Typography
            className="bodyB2RegularText"
            sx={{ color: "var(--text-medium, rgba(1, 1, 2, 0.60))" }}
          >
            {subHeaderText}
          </Typography>
          {dropdownData && (
            <div style={{ display: "flex", marginTop: "13px" }}>
              <CustomDropdown
                width={"228px"}
                optionsToSend={dropdownData?.optionsToSend}
                optionsToDisplay={dropdownData?.optionsToDisplay}
                updateSelect={dropdownData?.updateDropdownSelect}
                dropDownId={dropdownData?.dropDownId}
                defaultValue={dropdownData?.defaultValue}
              />
            </div>
          )}
        </div>
      </div>

      <DialogActions
        className="modal-footer"
        sx={{
          border: "0px",
          display: "flex",
          boxShadow: "0px -2px 8px 0px rgba(39, 39, 39, 0.15)",
        }}
      >
        {outlinedBtnText != "" && (
          <CustomButton
            text={outlinedBtnText}
            variant={"outlined"}
            type={type}
            size={"xs"}
            onClick={() => outlinedBtnFunction()}
          />
        )}
        {filledBtnText != "" && (
          <CustomButton
            text={filledBtnText}
            variant={"contained"}
            type={type}
            size={"xs"}
            loading={isFilledBtnLoading}
            onClick={() => filledBtnFunction()}
          />
        )}
      </DialogActions>
    </Dialog>
  );
};

SmallModal.defaultProps = {
  headerText: "Info",
  subHeaderText: "sub header text goes here",
  icon: <img src="/assets/orderDetailsIcons/ExclamationCircle-yellow.svg" />,
  outlinedBtnText: "",
  filledBtnText: "",
  outlinedBtnFunction: () => { },
  filledBtnFunction: () => { },
  toggleDialog: false,
  type: "secondary",
  dropdownData: null,
};

export default SmallModal;
